module.exports = __webpack_public_path__ + "static/media/tile-dna-methylation.6196c103.svg";